<template>
  <form @submit.prevent="submit">
    <Field
      label="Article Title"
      @input="$v.resource.heading.$touch()"
      @handleChange="handleChange"
      v-model="resource.heading"
      :error="headingError"
    />

    <Field
      label="Article Content"
      type="textarea"
      :allowImages="true"
      @input="$v.resource.content_md.$touch()"
      @handleChange="handleChange"
      v-model="resource.content_md"
      :error="content_mdError"
    />

    <DateTimePicker
      label="Publish At"
      helpText="This will publish the article at the selected date and time"
      @handleChange="handleChange"
      v-model="resource.published_at"
      :error="published_atError"
    />

    <Field
      label="Article URL"
      @input="$v.resource.slug.$touch()"
      @handleChange="handleChange"
      v-model="resource.slug"
      :preText="`${websiteUrl}/blog/`"
      :error="slugError"
    />

    <div class="btn-save">
      <btn :class="{'changes-made': changesMade}">Create Article</btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import DateTimePicker from '@/components/forms/inputs/DateTimePicker'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'ArticleForm',

  mixins: [form],

  components: {
    Btn,
    DateTimePicker
  },

  computed: {
    ...errorMessages(['heading', 'content_md', 'slug', 'published_at']),

    slug: {
      get() {
        return this.resource.slug
      },

      set(articleName) {
        let path = articleName.replace(/\s+/g, '-').toLowerCase()
        this.resource.slug = path
      }
    }
  },

  props: {
    websiteUrl: {
      type: String
    }
  },

  methods: {
    setInitialArticleSlug() {
      this.slug = this.resource.heading
    }
  },

  validations: {
    resource: {
      heading: {required},
      slug: {required},
      content_md: {required},
      published_at: {required},
      featured_image: {}
    }
  },

  watch: {
    'resource.heading'() {
      this.setInitialArticleSlug()
    }
  }
}
</script>
